import { useAuth } from "@clerk/clerk-react";
import { Grid, Skeleton, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { useContext, useEffect, useState } from "react";
import { OrganizationNiche } from "schemas/dashboard";

import StepsToPickTemplate from "features/Auth/SelfServeVaOnboarding/TemplatesPick/CreateYourOwnFlow/components/StepsToPickTemplate";
import { StepType } from "features/Auth/SelfServeVaOnboarding/TemplatesPick/schema";
import { fetcherAuth } from "utils/api";

interface Props {
  handleNext: () => void;
  saveOrgVaProfile: () => void;
}

const NicheTemplateForm = ({ handleNext, saveOrgVaProfile }: Props) => {
  const { getToken } = useAuth();
  const { currentOrg, profile, organizationVaProfile } = useContext(
    OrganizationUserContext,
  );
  const { fetchOutreachTemplatesLoading } = useContext(
    OutreachTemplatesContext,
  );

  const [steps, setSteps] = useState<StepType[]>([]);
  const [activeStep, setActiveStep] = useState(0);

  const moveToNextPage = () => {
    handleNext();
  };

  const fetchNiches = async () => {
    const { niches } = await fetcherAuth(
      getToken,
      `/api/organization/${currentOrg?.id}/organization-niches`,
    );

    const nichesWithNoTemplates = niches.filter(
      (niche: OrganizationNiche) =>
        !niche.emailSettingId && !niche?.needsTemplate,
    );
    if (nichesWithNoTemplates.length === 0) {
      moveToNextPage();
      return;
    }

    let activeStep = 0;
    let steps: StepType[] = [];
    for (const niche of nichesWithNoTemplates) {
      steps.push({
        label: `Select ${niche.name} Templates`,
        description: "",
        niche,
      });
    }
    setSteps(steps);
    setActiveStep(activeStep);
  };

  useEffect(() => {
    if (currentOrg?.id) {
      fetchNiches();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg?.id]);

  return (
    <>
      <Typography variant="h3" gutterBottom sx={{ textAlign: "center", mt: 0 }}>
        Set Your Templates For Niches
      </Typography>

      {fetchOutreachTemplatesLoading ? (
        <Grid>
          <Skeleton animation="wave" width="100%" height="50px" />
          <Skeleton animation="wave" width="100%" height="50px" />
          <Skeleton
            animation="wave"
            width="100%"
            height="400px"
            sx={{ mt: -10, mb: -8 }}
          />
          <Skeleton animation="wave" width="100%" height="80px" />
        </Grid>
      ) : (
        <StepsToPickTemplate
          steps={steps}
          setSteps={setSteps}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          organizationProfile={profile}
          organizationVaProfile={organizationVaProfile}
          saveOrgVaProfile={saveOrgVaProfile}
          moveToNextPage={moveToNextPage}
        />
      )}
    </>
  );
};

export default NicheTemplateForm;
